import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  // Device-side: start the device authorization flow (RFC 8628 §3.1).
  // Public client — authenticates by client_id only, no secret. The BE parses
  // application/x-www-form-urlencoded, so this request is emulated as form data.
  deviceAuthorization: {
    method: 'POST',
    url: `${configs.baseUrl}/api/auth/oauth/device_authorization`,
    emulateJSON: true,
  },
  lookup: {
    method: 'GET',
    url: `${configs.baseUrl}/api/auth/oauth/device/lookup`,
  },
  verify: {
    method: 'POST',
    url: `${configs.baseUrl}/api/auth/oauth/device/verify`,
  },
  // Device-side poll for tokens (RFC 8628 §3.4). Public client — client_id only,
  // no secret. Form-urlencoded, same as device_authorization.
  poll: {
    method: 'POST',
    url: `${configs.baseUrl}/api/auth/oauth/token`,
    emulateJSON: true,
  },
}

// RFC 8628 §3.4 grant_type for the device_code token poll.
const DEVICE_CODE_GRANT_TYPE = 'urn:ietf:params:oauth:grant-type:device_code'

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// Start the device authorization flow for a public client (client_id only).
// Returns: { device_code, user_code, verification_uri, verification_uri_complete,
// expires_in, interval }.
const deviceAuthorization = async (clientId) => {
  const res = await resource.deviceAuthorization({ client_id: clientId })
  return res.body
}

// Resolve a user_code to the pending request's app name + scopes.
// Returns the response body: { client_name, scopes, user_code } on success.
const lookup = async (userCode) => {
  const res = await resource.lookup({ user_code: userCode })
  return res.body
}

// Approve or deny a pending device authorization. action: 'approve' | 'deny'.
const verify = async ({ userCode, action }) => {
  const res = await resource.verify({ user_code: userCode, action })
  return res.body
}

// Poll the token endpoint once for a pending device authorization. Resolves with
// the token body on success ({ access_token, refresh_token, token_type,
// expires_in }). On a still-pending / throttled / terminal outcome the BE replies
// 400/401 and vue-resource rejects with the response; callers read err.body.error
// ('authorization_pending' | 'slow_down' | 'access_denied' | 'expired_token' | …).
const poll = async ({ deviceCode, clientId }) => {
  const res = await resource.poll({
    grant_type: DEVICE_CODE_GRANT_TYPE,
    client_id: clientId,
    device_code: deviceCode,
  })
  return res.body
}

export default {
  initResource,
  deviceAuthorization,
  lookup,
  verify,
  poll,
}
